import { useState, useEffect, useRef } from 'react';
import React from "react"
import './mobile_phone_footer.scss'

const CallFooter = () => {
  const [isVisible, setIsVisible] = useState(false);
  const lastScrollY = useRef(0);
  const scrollThreshold = 50; 

  const handleScroll = () => {
    const currentScrollY = window.scrollY;

    if (currentScrollY < lastScrollY.current && currentScrollY > scrollThreshold) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }

    lastScrollY.current = currentScrollY;
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={`call-footer ${isVisible ? 'visible' : ''}`}>
      <a href="/demo" className="call-button bg-primary">
         Request Demo
      </a>
    </div>
  );
};

export default CallFooter;
